module.exports = __webpack_public_path__ + "assets/favicons/safari-pinned-tab.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/safari-pinned-tab.svg
// module id = 1242
// module chunks = 1